import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';
import ConditionalRendering from '../ConditionalRendering';
import Spacing from '../Spacing';

import ModalTitle from './ModalTitle';
import ModalClose from './ModalClose';

const defaultProps = {
  title: '',
  showCloseButton: true,
  noPadding: false,
  disabled: false,
  onClosePress: () => {},
};

const propTypes = {
  title: PropTypes.string,
  showCloseButton: PropTypes.bool,
  noPadding: PropTypes.bool,
  disabled: PropTypes.bool,
  onClosePress: PropTypes.func,
};

const ModalHeader = ({
  title,
  showCloseButton,
  noPadding,
  disabled,
  onClosePress,
}) => (
  <Flex
    alignItems="center"
    className={classnames(
      'lg:h-10',
      !noPadding && 'pt-6 px-10',
    )}
  >
    <ConditionalRendering on={title !== ''}>
      <ModalTitle>
        {title}
      </ModalTitle>
    </ConditionalRendering>
    <ConditionalRendering on={showCloseButton}>
      <Spacing left="auto">
        <ModalClose
          disabled={disabled}
          onClick={onClosePress}
        />
      </Spacing>
    </ConditionalRendering>
  </Flex>
);

ModalHeader.defaultProps = defaultProps;
ModalHeader.propTypes = propTypes;

export default ModalHeader;
